var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowBackIosWhite20(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "arrow_back_ios"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_733_2603",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_733_2603)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "arrow_back_ios_2",
    d: "M13.1042 17.4267L6.25479 10.5693C6.16292 10.4774 6.09749 10.3847 6.0585 10.2912C6.0195 10.1978 6 10.1008 6 10.0004C6 9.89997 6.0195 9.80301 6.0585 9.70954C6.09749 9.61606 6.16292 9.52337 6.25481 9.4315L13.133 2.55329C13.3039 2.38235 13.5067 2.29688 13.7412 2.29688C13.9757 2.29688 14.1784 2.38929 14.3493 2.57412C14.5288 2.73972 14.6116 2.94858 14.5977 3.20071C14.5838 3.45285 14.4941 3.66172 14.3285 3.82731L8.15542 10.0004L14.3573 16.2023C14.5144 16.3594 14.5929 16.5634 14.5929 16.8145C14.5929 17.0656 14.5144 17.2696 14.3573 17.4267C14.1917 17.5923 13.9829 17.6751 13.7308 17.6751C13.4786 17.6751 13.2698 17.5923 13.1042 17.4267Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackIosWhite20);
export default __webpack_public_path__ + "static/media/arrow_back_ios_white_20.eb549681faf5ca1b2150c45007241a74.svg";
export { ForwardRef as ReactComponent };